import { ActionTypes } from "../type";

const initialState = {
  registration_serach: null,
  appointment_booking: null,
};

export const RegistrationSerachReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.SUBMIT_REGISTRATION_SEARCH:
      return { ...state, registration_serach: action.payload };
    case ActionTypes.CLEAR_REGISTRATION_SEARCH:
      return { registration_serach: null };
    case ActionTypes.SUBMIT_APPOINTMENT_BOOKING_MASTER:
      return { ...state, appointment_booking: action.payload };
    default:
      return state;
  }
};
